import React, {FunctionComponent} from "react";

const styles = require("./caseStats.module.scss");


interface Props {
    statsData: {
        icon: string;
        label: string;
        data: string;
    }[];
}

export const CaseStats: FunctionComponent<Props> = props => {
    const {statsData} = props;
    return (
        <div className={styles.statsContainer}>
            {statsData && statsData.map(stat =>
                <div key={stat.label} className={styles.oneStat}>
                    <div className={styles.upperStat}>
                        <i className={`${stat.icon} ${styles.icon}`}/>
                        {stat.label}
                    </div>
                    <div className={styles.bottomStat}>
                        {stat.data}
                    </div>
                </div>
            )}
        </div>
    );
};